import { ClessonResult } from '../../../typings';
import { getFetch } from '../fetch';
import { apiConfig } from '../config';

export interface GetClessonsResultsRequestData {
    clessonIds: number[];
}

export type GetClessonsResultsResponseData = ClessonResult[];

export function getClessonsResults(request: GetClessonsResultsRequestData): Promise<GetClessonsResultsResponseData> {
    const { clessonIds } = request;
    const { apiGetClessonResultsBulk } = apiConfig.getStaticUrls();

    return getFetch(apiGetClessonResultsBulk, {
        clesson: clessonIds.join(','),
    });
}
